import './TopNavigationBar.css';

import * as React from 'react';
import { AppBar, Toolbar } from '@mui/material';
import { Link } from 'react-router-dom';
import { styled } from '@mui/system';
import SelectOrg from './SelectOrg';
import IconMenu, { UserAvatar } from './IconMenu';
import { Business, DashboardCustomize, ErrorOutline, Logout, ManageAccounts, NotificationsNone, PersonAddAlt, PersonOutline } from '@mui/icons-material';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';
import useLogout from '../hooks/useLogout';
import OrganizationWidgetModal from '../../b2b-reporting/forms/OrganizationWidgetModal';

const StyledAppBar = styled(AppBar)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.palette.primary.main,
}));

export default function TopNavigationBar() {
    const handleLogout = useLogout();
    const { t } = useB2BTranslation('b2b-common');
    const [showWidgetModal, setShowWidgetModal] = React.useState(false);

    return (
        <StyledAppBar position="fixed" className='b2b-header-container'>
            <Toolbar className='b2b-topbar'>
                <div className='b2b-topbar-group-left'>
                    <Link to="/login">
                        <img src="/images/imagotipo-app.svg" alt="logo" className='b2b-logo' />
                    </Link>
                    <SelectOrg />
                </div>
                <div className='b2b-topbar-group-right'>
                    <IconMenu
                        icon={<Business />}
                        options={[
                            {
                                label: t('Organization profile'), path: '/users/company-profile', icon: < Business />,
                                roles: ['ROLE_ADMIN'],
                                products: ['B2B_BASE'],
                            },
                            {
                                label: t('Add to Dashboards'), icon: <DashboardCustomize />,
                                onClick: () => setShowWidgetModal(true),
                                roles: ['ROLE_ADMIN'],
                                products: ['B2B_CUSTOM_DASHBOARDS'],
                            },
                        ]}
                        rolesAllowed={['ROLE_ADMIN']}
                        b2bProducts={['B2B_BASE']}
                    />
                    <IconMenu
                        icon={<PersonOutline />}
                        options={[
                            {
                                label: t('Organization users'), path: '/users/organization-users', icon: < ManageAccounts />,
                                roles: ['ROLE_ADMIN'],
                                products: ['B2B_BASE'],
                            },
                        ]}
                        rolesAllowed={['ROLE_ADMIN']}
                        b2bProducts={['B2B_BASE']}
                    />
                    <IconMenu
                        icon={<NotificationsNone />}
                        options={[
                            { label: t('No alerts'), path: '/page1', icon: < ErrorOutline /> },
                        ]}
                    />
                    <IconMenu
                        icon={<UserAvatar />}
                        options={[
                            {
                                label: t('My profile'), path: '/users/user-profile', icon: < PersonOutline />,
                            },
                            {
                                label: t('Logout'), icon: < Logout />,
                                onClick: () => handleLogout(),
                            },
                        ]}
                    />
                    {showWidgetModal && (
                        <OrganizationWidgetModal
                            open={showWidgetModal}
                            onCancel={() => setShowWidgetModal(false)}
                            onSaved={() => setShowWidgetModal(false)}
                        />
                    )}
                </div>
            </Toolbar>
        </StyledAppBar>
    );
}